import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { StoreAction } from 'store/actions';
import { DeviceReturnEligible, FindMyDeviceStatus, ReasonCodes, ReturnInfo } from './models';
import { buildHeaders, XmStore } from 'core/services';
import { ApiChannel } from 'core/constants';

@Injectable()
export class ReturnApi {
    public static getReasonCodes(_xmStore: XmStore, http: HttpClient): Observable<ReasonCodes> {
        return http.get('/reasoncodes', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((codes: ApiResponse) => ReasonCodes.create<ReasonCodes>({ codes }))
        );
    }

    public static submitReturn(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ReturnInfo> {
        const deviceId: string = params.deviceId;
        delete params.deviceId;

        return http.post(`/devices/${deviceId}/return`, params, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((info: ReturnInfo) => ReturnInfo.create<ReturnInfo>({ ...info, orderValue: info.returnOrderSuccess.returnOrderId.value }))
        );
    }

    public static getDeviceReturnEligible(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<DeviceReturnEligible> {
        return http.get(`/devices/${params.deviceId}/returneligibility`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => DeviceReturnEligible.create<DeviceReturnEligible>({ ...response, deviceId: params.deviceId }))
        );
    }

    public static getFindMyDeviceStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<FindMyDeviceStatus> {
        return http.get(`/devices/${params.imei}/findmydevicestatus`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((status: FindMyDeviceStatus) => FindMyDeviceStatus.create<FindMyDeviceStatus>({ ...status, imei: params.imei }))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_REASON_CODES] = ReturnApi.getReasonCodes;
ModelBase.persistMapping[StoreAction.INITIATE_RETURN] = ReturnApi.submitReturn;
ModelBase.fetchMapping[StoreAction.GET_DEVICE_RETURN_ELIGIBLE] = ReturnApi.getDeviceReturnEligible;
ModelBase.fetchMapping[StoreAction.GET_FIND_MY_DEVICE_STATUS] = ReturnApi.getFindMyDeviceStatus;
